module.exports = __webpack_public_path__ + "media/images/small-world-fd7f709fcd728d386dc6067c48ecbb60.png";